import React, { useEffect, useState } from 'react'
import styles from "./corpus.module.css"
import { axiosInstance } from '../../Helpers/axiosInstance'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'
import wStiles from "../Weapon/Weapon.module.css"
import "../../App.css"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'


export default function Corpus() {
    const [corpusName, setCorpusName] = useState("")
    const [corpusNumber, setCorpusNumber] = useState("")
    const [corpusFullName, setCorpusFullName] = useState("")
    const [corpuses, setCorpuses] = useState([])
    const [change, setChange] = useState(null)

    useEffect(() => {
        (async() => {
            const corpuses = await axiosInstance.get('admin/corpuses')
            if(corpuses.status){
                setCorpuses(corpuses.data.data)
            }
        })()
    }, [])

    useEffect(() => {
        if(corpusFullName){
            const [number, name] = corpusFullName.split(" ")
            setCorpusNumber(number)
            setCorpusName(name)
        }
    }, [corpusFullName])

    const submitHandler = async () => {
        const res = await axiosInstance.post('admin/corpus', {corpus_name: corpusName, corpus_number: corpusNumber})
        if(res.data.status){
            setChange(null)
            setCorpusName("")
            setCorpusNumber("")
            setCorpusFullName("")
            setCorpuses([...corpuses, res.data.data])
            toast.success("Կորպուսը հաջողությամբ ավելացվեց");
        }
    }

    const changeCorpus = async (el) => {
        setChange(el)
        setCorpusName(el.corpus_name)
        setCorpusNumber(el.corpus_number)
        setCorpusFullName(el.corpus_number + " " + el.corpus_name)
    }

    const changeHandler = async () => {
        const res = await axiosInstance.put(`admin/corpus/${change._id}`, {corpus_name: corpusName, corpus_number: corpusNumber})
        if(res.status){
            setChange(null)
            setCorpuses(p => {
                let index = corpuses.findIndex(el => el._id === change._id)
                const newCorpuses = [...corpuses]
                newCorpuses[index] = {...change, corpus_name: corpusName, corpus_number: corpusNumber}
                return newCorpuses
            })
            setCorpusName("")
            setCorpusNumber("")
            setCorpusFullName("")
            toast.success("Կորպուսը հաջողությամբ փոփոխվեց");
        }
    }

    const deleteCorpus = async (el) => {
        const res = await axiosInstance.delete(`admin/corpus/${el._id}`)
        if(res.data.status){
            setCorpuses(p => p.filter(corpus => corpus._id !== el._id))
            toast.success("Կորպուսը հաջողությամբ ջնջվեց");
        }
    }


  return (
    <div className={styles["corpus-main-div"]}>
        <div className={styles["corpus-container"]}>
            <h2>Լրացրեք կորպուսի տվյալները</h2>
            <div>
                <label htmlFor="corpusNumber">Կորպուսի համար / Կորպուսի անվանում</label>
                <input type="text" id="corpusNumber" value={corpusFullName} onChange={(e) => setCorpusFullName(e.target.value)}  />
            </div>
            <button className={`confirm-btn`} onClick={() => change ? changeHandler() : submitHandler()}>{change ? "Փոփոխել" : "Ավելացնել"}</button>
        </div>
        <div className={styles["corpus-list"]}>
            <h2>Կորպուսներ</h2>
            <ol>
                <li className={styles["corpus-list-item"]}>
                    <p className='per3 start'>Կորպուսի համար</p>
                    <p className='per3 end'>Ղեկավարման կոճակներ</p>
                </li>
                {corpuses?.map((el, index) => {
                    return <li key={index} className={styles["corpus-list-item"]}>
                            <p className='per3 start'>{el?.corpus_number + " " + el?.corpus_name}</p>
                            <div className='per3 end'>
                                <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => changeCorpus(el)}><FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել"/></button>
                                <button className={`btn ${styles["corpus-list-item-button"]}`} onClick={() => deleteCorpus(el)}><FontAwesomeIcon icon={faTrash} className={styles["edit"]} title="Ջնջել"/></button>
                            </div>
                        </li>
                })}
            </ol>
        </div>
        <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}
